import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as DocumentCategoryActions from './document-category.actions';
import { DocumentCategoryService } from '../../services/document-category.service';

@Injectable()
export class DocumentCategoryEffects {
  loadDocumentCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentCategoryActions.loadDocumentCategory),
      exhaustMap((_) =>
        this.documentCategoryService.getDocumentCategory().pipe(
          map((data) =>
            DocumentCategoryActions.loadDocumentCategorySuccess({
              documentCategory: data,
            })
          ),
          catchError((error) =>
            of(DocumentCategoryActions.loadDocumentCategoryFailure({ error }))
          )
        )
      )
    )
  );

  addDocumentCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentCategoryActions.addDocumentCategory),
      concatMap(({ newDocumentCategory }) =>
        this.documentCategoryService
          .createDocumentCategory(newDocumentCategory)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return DocumentCategoryActions.addDocumentCategorySuccess({
                newDocumentCategory: data,
              });
            }),
            catchError((error) =>
              of(
                DocumentCategoryActions.addDocumentCategoryFailure({
                  error: error.error.message,
                })
              )
            )
          )
      )
    )
  );

  updateDocumentCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentCategoryActions.updateDocumentCategory),
      map((action) => action.updateDocumentCategory),
      concatMap((updateDocumentCategory) =>
        this.documentCategoryService
          .updateDocumentCategory(updateDocumentCategory)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return DocumentCategoryActions.updateDocumentCategorySuccess({
                updateDocumentCategory: updateDocumentCategory,
              });
            }),
            catchError((error) =>
              of(
                DocumentCategoryActions.updateDocumentCategoryFailure({
                  error: error.message,
                })
              )
            )
          )
      )
    )
  );

  removeDocumentCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentCategoryActions.removeDocumentCategory),
      map((action) => action.ids),
      concatMap((ids) =>
        this.documentCategoryService.deleteDocumentCategory(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return DocumentCategoryActions.removeDocumentCategorySuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              DocumentCategoryActions.updateDocumentCategoryFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private documentCategoryService: DocumentCategoryService,
    private notification: NotificationService
  ) {}
}
